// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-51850ee1]{display:none}.banner[data-v-51850ee1]{cursor:pointer;position:relative;overflow:hidden;display:block;height:100%;border:1px solid #dadada}.banner__image[data-v-51850ee1]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;position:absolute;top:0;right:0;bottom:0;left:0}.banner--srp[data-v-51850ee1]{min-height:140px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
